import React, { PureComponent } from "react";
import { PieChart, Pie, Cell, Legend, Tooltip } from "recharts";

export default class ChartPie extends PureComponent<any, any> {
    UNSAFE_componentWillReceiveProps() {}
    // static jsfiddleUrl = 'https://jsfiddle.net/alidingling/c9pL8k61/';
    render() {
        return (
            <PieChart width={500} height={230}>
                <Pie
                    data={this.props.data}
                    cx={250}
                    cy={80}
                    labelLine={false}
                    //@ts-ignore
                    label={this.props.render}
                    outerRadius={80}
                    fill="#8884d8"
                    dataKey="value"
                >
                    {this.props.data.map((entry: any, index: number) => (
                        <Cell key={`cell-${index}`} fill={this.props.color[index % this.props.color.length]} />
                    ))}
                </Pie>
                <Tooltip
                    separator=""
                    // content={
                    //     //@ts-ignore
                    //     <this.CustomizedTooltip />
                    // }
                    // wrapperStyle={{ backgroundColor: "red" }}
                    // labelStyle={{ color: "green" }}
                    // itemStyle={{ color: "cyan" }}
                    formatter={function (value, name, props) {
                        // return [`${value} %`, "formatted name"];
                        return [`${name} - ${value} Terbitan`];
                    }}
                    labelFormatter={function (value) {
                        return `${value}`;
                    }}
                />
                <Legend />
            </PieChart>
        );
    }
}
